import {
  Prices,
  Selection,
  PriceAttribute,
} from '@printdeal/product-selector';
import Api from '../Api';

type ProductQuantity = {
  edoId: string;
  quantity: number;
};

export interface ProductConfigurationPrices {
  productPageId: string;
  configuration: PriceAttribute[];
  prices: Prices;
}

export interface ProductConfigurationPopularity {
  productPageId: string;
  configuration: PriceAttribute[];
  quantity: ProductQuantity;
}

export interface InvalidateProductConfigurationPrices {
  productPageId: string;
  configurationHash: string;
}

interface ProductTypeMainSelection {
  message: string;
  status: 'success' | 'error';
  data: {
    product_type_code: string;
    products: Record<string, Selection>;
    product_combinations: Record<string, number>;
    products_count: number;
    total_combinations: number;
  };
}

type CheapestPriceAttributes = {
  deliveryType: string;
  printingProcess: string;
  quantity: number;
};

type DynamicRoute = {
  productPageId: string;
  configurationHash: string;
  configuration: PriceAttribute[];
  quantity: ProductQuantity;
  cheapestPriceAmount: number;
  cheapestPriceAttributes: CheapestPriceAttributes;
};

class DynamicProductRoutesService extends Api {
  async getMostPopularDynamicProductRoute(productpageId: string): Promise<DynamicRoute> {
    const { data } = await this.httpClient.get<DynamicRoute>(`/product-routes/popular/${productpageId}`);
    return data;
  }

  async saveProductConfigurationPopularity(payload: ProductConfigurationPopularity): Promise<void> {
    const { data } = await this.httpClient.post<void>('/popularity-tracking', payload);
    return data;
  }

  async saveProductConfigurationPrices(payload: ProductConfigurationPrices): Promise<void> {
    const { data } = await this.httpClient.post<void>('/price-tables', payload);
    return data;
  }

  async invalidateProductConfigurationPrices({
    productPageId,
    configurationHash,
  }: InvalidateProductConfigurationPrices): Promise<void> {
    const { data } = await this.httpClient.delete<void>(`/price-tables/${productPageId}/${configurationHash}`);
    return data;
  }

  async getProductTemplateSelection(productType: string): Promise<ProductTypeMainSelection> {
    const { data } = await this.httpClient.get<ProductTypeMainSelection>(`/product-templates/selection/${productType}`);
    return data;
  }
}

export default DynamicProductRoutesService;
